export function accessibleDropdown() {
    window.addEventListener('load', function () {
        let contextDropdown = document.querySelector('#contextFieldset') as HTMLElement;
        let transcriptsDropdown = document.querySelector('#transcriptFieldset') as HTMLElement;
        let fieldset = contextDropdown ? contextDropdown : transcriptsDropdown ? transcriptsDropdown : null;

        if (fieldset != null) {
            fieldset.addEventListener('focus', function () {
                let currentInput = fieldset.querySelector('[data-checked="true"]');
                let currentInputParent = currentInput.parentElement;
                let radioInputs = Array.prototype.slice.call(fieldset.querySelectorAll('input'));

                radioInputs.forEach(radio => {
                    radio.style.display = 'block';

                    let radioElement = radio as HTMLElement;
                    radioElement.parentElement.setAttribute('aria-selected', 'false');
                })

                fieldset.setAttribute('aria-activedescendant', currentInput.id);
                fieldset.setAttribute('aria-expanded', 'true');

                fieldset.addEventListener("keydown", function (e) {
                    // Arrow up
                    if (e.keyCode == 38) {
                        e.preventDefault();
                        if (currentInputParent.previousElementSibling) {
                            radioInputs.forEach(radio => {
                                radio.style.display = 'block';

                                let radioElement = radio as HTMLElement;
                                radioElement.parentElement.setAttribute('aria-selected', 'false');
                            })

                            let prev = currentInputParent.previousElementSibling as HTMLElement;
                            let prevInputId = prev.querySelector('input').id;
                            prev.setAttribute('aria-selected', 'true');
                            currentInputParent = prev;
                            fieldset.setAttribute('aria-activedescendant', prevInputId);
                        }
                    }
                    // Arrow down
                    else if (e.keyCode == 40) {
                        e.preventDefault();
                        if (currentInputParent.nextElementSibling) {
                            radioInputs.forEach(radio => {
                                radio.style.display = 'block';

                                let radioElement = radio as HTMLElement;
                                radioElement.parentElement.setAttribute('aria-selected', 'false');
                            })

                            let next = currentInputParent.nextElementSibling as HTMLElement;
                            let nextInputId = next.querySelector('input').id;
                            next.setAttribute('aria-selected', 'true');
                            currentInputParent = next;
                            fieldset.setAttribute('aria-activedescendant', nextInputId);
                        }
                    }
                    // Enter
                    else if (e.keyCode == 13) {
                        let currentInputLabel = currentInputParent.querySelector('label');

                        currentInputLabel.click();
                    }
                    // Tab
                    else if (e.keyCode == 9) {
                        radioInputs.forEach(radio => {
                            radio.style.display = 'none';
                        })

                        currentInputParent.setAttribute('aria-selected', 'false');
                        currentInputParent = fieldset.querySelector('[data-checked="true"]').parentElement;
                    }
                })
            })
        }
    })
}